export default __webpack_public_path__ + "6d14072a08ceb6d6d65d84223df9c737.png";